var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 145",
    style: {
      enableBackground: "new 0 0 145 145"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "women_3"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#876450"
    },
    width: 145,
    height: 145
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10303F"
    },
    d: "M49.646,74.68c0,0,3.857,14.342,13.682,17.958c15.342,0,17.859,0.322,17.859,0.322 s11.822-4.246,15.984-20.95c-2.395-25.392-19.945-33.192-19.945-33.192L49.646,74.68z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M108.981,115.699c-4.963-9.396-36.482-15.597-36.482-15.597s-31.622,5.701-36.944,15.544 c-3.67,13.038-6.428,29.198-6.428,29.198L72.499,145l42.712-0.197C115.211,144.803,113.645,127.541,108.981,115.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.499,100.103c0,0,31.912,5.896,36.875,15.292c4.664,11.842,6.738,29.605,6.738,29.605H72.499 V100.103z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.813,
    y: 81.001,
    style: {
      fill: "#F1C9A5"
    },
    width: 17.373,
    height: 29.077
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.499,
    y: 81.001,
    style: {
      fill: "#E4B692"
    },
    width: 8.688,
    height: 29.077
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C",
      enableBackground: "new"
    },
    d: "M63.813,94.475c1.561,4.485,7.867,7.057,12.498,7.057 c1.676,0,3.307-0.28,4.875-0.795V81.001H63.813V94.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M94.837,62.653c0-18.162-10-28.489-22.338-28.489c-12.336,0-22.338,10.327-22.338,28.489 s10.002,32.886,22.338,32.886C84.837,95.539,94.837,80.815,94.837,62.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M92.235,75.247c-4.049-0.416-6.783-4.711-6.098-9.586c0.678-4.878,4.512-8.5,8.564-8.084 c4.047,0.415,6.15,4.743,5.467,9.622C99.491,72.077,96.284,75.659,92.235,75.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M44.407,67.162c-0.684-4.879,2.047-9.17,6.092-9.585c4.053-0.416,7.889,3.206,8.566,8.084 c0.684,4.875-2.051,9.17-6.1,9.586C48.917,75.659,45.087,72.04,44.407,67.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M94.837,62.653c0-18.162-10-28.489-22.338-28.489v61.375 C84.837,95.539,94.837,80.815,94.837,62.653z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAE43E"
    },
    d: "M71.753,38.748c11.531,0,21.109,6.656,23.059,15.418c0.238-1.069,0.369-2.17,0.369-3.294 c0-10.333-10.488-18.712-23.428-18.712c-12.938,0-23.426,8.379-23.426,18.712c0,1.124,0.131,2.225,0.371,3.294 C50.646,45.404,60.224,38.748,71.753,38.748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3D4C"
    },
    d: "M109.374,115.395c-1.311-2.481-4.506-4.716-8.49-6.665c-6.246,1.154-16.627,1.91-28.385,1.91 s-22.137-0.756-28.383-1.91c-3.986,1.949-7.18,4.184-8.49,6.665C31.956,128.433,28.888,145,28.888,145h43.611h43.613 C116.112,145,114.038,127.236,109.374,115.395z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10303F"
    },
    d: "M87.29,43.611c0,0,0.488,9.795-13.381,21.922c3.408-5.597,3.408-9.329,3.408-9.329 s-2.861,5.977-11.256,11.924c1.004-2.535,3.834-11.719,3.834-11.719s-5.385,8.308-8.121,13.555 c1.096-4.197,1.732-10.493,6.752-15.303c-4.563,2.535-11.588,10.056-11.314,19.589c-1.643-2.274-1.186-10.231-1.186-10.231 s-4.105,3.673-2.738,17.839c-1.459-1.748-3.193-16.79-3.193-16.79s-3.07,2.682-2.707,11.193 c-3.527-6.064-14.645-36.757,21.777-47.808c0,0,20.072-4.49,28.648,13.001c8.578,17.49,0.549,35.157-3.467,41.278 c1.277-5.597,2.463-10.145,1.734-12.68c-1.369,4.984-5.566,6.034-5.566,6.034s5.109-6.909,4.746-10.758 c-3.834,5.86-8.394,6.821-8.852,6.646c6.934-8.832,6.934-12.943,6.662-16.091c-3.012,7.259-6.389,8.921-6.389,8.921 s5.475-10.583,5.475-15.218c-3.74,6.471-4.469,6.734-6.021,8.221C88.874,53.698,88.628,46.645,87.29,43.611z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F06B7E"
    },
    points: "73.026,122.079 75.108,128.492 81.853,128.492 76.396,132.454 78.479,138.866  73.026,134.903 67.571,138.866 69.655,132.454 64.2,128.492 70.942,128.492  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F06B7E"
    },
    points: "85.505,127.221 87.019,131.881 91.917,131.881 87.954,134.761 89.468,139.418  85.505,136.538 81.542,139.418 83.056,134.761 79.093,131.881 83.991,131.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F06B7E"
    },
    points: "59.128,127.221 60.64,131.881 65.54,131.881 61.577,134.761 63.091,139.418  59.128,136.538 55.163,139.418 56.679,134.761 52.714,131.881 57.612,131.881  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.887304edee2fa8ce23652ef36f6523cd.svg";
export { ForwardRef as ReactComponent };